export default __webpack_public_path__ + "static/media/15943.e4556c58.png";